import React, { useState } from 'react';
import { Box, Typography, Button, TextField, Container, Grid, Select, MenuItem, InputLabel, FormControl } from '@mui/material';
import { SelectChangeEvent } from '@mui/material/Select';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

const Contact: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    selection: '',
    message: '',
  });

  const [errors, setErrors] = useState({
    name: '',
    email: '',
    company: '',
    selection: '',
    message: '',
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | SelectChangeEvent<string>) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name as string]: value,
    });
    // 入力時にエラーをクリア
    setErrors({
      ...errors,
      [name as string]: '',
    });
  };

  const validate = () => {
    let tempErrors = {
      name: '',
      email: '',
      company: '',
      selection: '',
      message: '',
    };
    let isValid = true;

    if (!formData.name) {
      tempErrors.name = 'お名前は必須です。';
      isValid = false;
    }
    if (!formData.email) {
      tempErrors.email = 'メールアドレスは必須です。';
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      tempErrors.email = '有効なメールアドレスを入力してください。';
      isValid = false;
    }
    if (!formData.company) {
      tempErrors.company = '会社名は必須です。';
      isValid = false;
    }
    if (!formData.selection) {
      tempErrors.selection = '問い合わせの目的を選択してください。';
      isValid = false;
    }
    if (!formData.message) {
      tempErrors.message = 'お問い合わせ内容は必須です。';
      isValid = false;
    }

    setErrors(tempErrors);
    return isValid;
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (validate()) {
      // フォーム送信ロジック（仮）
      console.log('Form data submitted:', formData);
      alert('お問い合わせを送信しました。');
      // フォームをリセット
      setFormData({
        name: '',
        email: '',
        company: '',
        selection: '',
        message: '',
      });
    } else {
      console.log('Validation failed');
    }
  };
  const [downloaded, setDownloaded] = useState(false);
  return (
    <Box
      id="contact"
      sx={{
        padding: '80px 20px',
        textAlign: 'center',
      }}
    >
      <Container maxWidth="lg"> {/* Gridを使用するためmaxWidthを広げました */}
        <Grid container spacing={4} justifyContent="center"> {/* Gridコンテナ */}
          <Grid item xs={12} md={6}> {/* 資料ダウンロードセクション */}
            <Box sx={{ marginBottom: '60px' }}>
              <Typography variant="h5" component="h3" sx={{ color: '#555', marginBottom: '20px' }}>
                資料ダウンロード
              </Typography>
              <Typography variant="body1" sx={{ marginBottom: '20px' }}>
                問い合わせ不要で、NextIの詳細資料をダウンロードいただけます。
              </Typography>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  // ダウンロード処理
                  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
                    const link = document.createElement('a');
                    link.href = 'https://firebasestorage.googleapis.com/v0/b/ludyworkshp.firebasestorage.app/o/NextI.pdf?alt=media&token=6eda690e-45fc-450c-a010-1bf51bd5499c'; // ダウンロードするファイルのパス
                    link.download = '資料.pdf'; // ダウンロードするファイル名
                    link.target = '_blank';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    setDownloaded(true); // ダウンロード完了フラグを設定
                  }
                }}
                sx={{ padding: '15px 15px', fontSize: '1.2em' }}
              >
                <FileDownloadIcon sx={{ marginRight: '10px' }} />
                資料をダウンロード
              </Button>
              {downloaded && (
                <Typography variant="body1" sx={{ marginTop: '10px'}}>
                  資料をダウンロードいただき、ありがとうございました。<br/>
                  問い合わせフォームよりお問い合わせいただければ、担当者よりご説明いたします。
                </Typography>
              )}
            </Box>
          </Grid>

          <Grid item xs={12} md={6}> {/* お問い合わせフォームセクション */}
            <Box sx={{ marginBottom: '60px'}}>
              <Typography variant="h5" component="h3" sx={{ color: '#555', marginBottom: '20px' }}>
                お問い合わせフォーム
              </Typography>
              <Box
                component="form"
                onSubmit={handleSubmit} // onSubmitハンドラを追加
                sx={{
                  maxWidth: '600px',
                  margin: '0 auto',
                  padding: '30px',
                  backgroundColor: 'white',
                  borderRadius: '8px',
                  boxShadow: downloaded ? '2px 5px 10px rgba(0, 0, 0, 0.5)' : '0 2px 10px rgba(0, 0, 0, 0.1)',
                  textAlign: 'left',
                }}
              >
                <TextField
                  fullWidth
                  label="お名前"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  error={!!errors.name}
                  helperText={errors.name}
                  required
                  margin="normal"
                />
                <TextField
                  fullWidth
                  label="メールアドレス"
                  id="email"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  error={!!errors.email}
                  helperText={errors.email}
                  required
                  margin="normal"
                />
                <TextField
                  fullWidth
                  label="会社名"
                  id="company"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  error={!!errors.company}
                  helperText={errors.company}
                  required
                  margin="normal"
                />
                <FormControl fullWidth margin="normal" error={!!errors.selection}>
                  <InputLabel id="selection-label">問い合わせの目的</InputLabel>
                  <Select
                    labelId="selection-label"
                    id="selection"
                    name="selection"
                    value={formData.selection}
                    onChange={handleChange}
                    label="問い合わせの目的"
                    required
                  >
                    <MenuItem value="option1">導入を検討中</MenuItem>
                    <MenuItem value="option2">代理店制度について知りたい</MenuItem>
                    <MenuItem value="option3">その他</MenuItem>
                  </Select>
                  {errors.selection && <Typography color="error" variant="caption">{errors.selection}</Typography>}
                </FormControl>
                <TextField
                  fullWidth
                  label="お問い合わせ内容"
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  error={!!errors.message}
                  helperText={errors.message}
                  multiline
                  rows={4}
                  required
                  margin="normal"
                />
                <Button
                  type="submit"
                  variant="contained"
                  color="success"
                  fullWidth
                  sx={{ marginTop: '20px', padding: '15px', fontSize: '1.2em' }}
                >
                  送信
                </Button>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Contact;
